export default defineNuxtPlugin(async () => {
  const container = document.createElement("div");
  container.setAttribute("id", "v-image-light-box");
  document.body.appendChild(container);
});
